import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import {countMessage} from '@/api/home'

// 创建VUEX对象
const store = new Vuex.Store({
	state: {
		pendingAudit: {
			customerCount: 0, // 新客户
			purchaseCount: 0, // 采购
			purchaseRefundCount: 0, // 采购退货
			orderCount: 0, // 订单
			orderRefundCount: 0, // 订单退货
			designCount: 0, // 设计图纸
			salaryCount: 0, // 薪资
			perkCount: 0, // 补助
			billCount: 0, // 账单
		},
		todoTaskCount: 0,
		unreadNoticeCount: 0
	},
	getters: {
		pendingAuditCount(state) {
			let totalCount = 0
			Object.keys(state.pendingAudit).forEach(key=> {
				totalCount += state.pendingAudit[key]
			})
			return totalCount
		}
	},
	mutations: {
		initState(state, payload) {
			state.pendingAudit = payload.pendingAudit
			state.todoTaskCount = payload.todoTaskCount
			state.unreadNoticeCount = payload.unreadNoticeCount
		},
		reducePendingAudit(state, payload) {
			state.pendingAudit[payload.field] = state.pendingAudit[payload.field] > 1 ? --state.pendingAudit[payload.field] : 0
		},
		clearUnreadNotice(state) {
			state.unreadNoticeCount = 0
		}
	},
	actions: {
		loadMessage(context) {
			countMessage().then(res=> {
				context.commit('initState', {
					pendingAudit: res.data.pendingAudit,
					todoTaskCount: res.data.todoTaskCount,
					unreadNoticeCount: res.data.unreadNoticeCount
				})
			})
		}
	}
})

export default store